<div class="menu-grid margin-footer container">
  <div class="menu-grid-menu">
    <app-calendar-config></app-calendar-config>
  </div>

  <div id="calendar">
    <mat-card appearance="outlined" class="p-0 calendar-body">
      <mat-card-content class="p-0">
        <app-todo-table [data]="todoData" (onEditEvent)="onEditEvent()"></app-todo-table>
        <div style="display: none">
          <!--Ces boutons sont invisibles mais necessaires pour la navigation-->
          <div class="cal-top-col text-center">
            <button mat-icon-button mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" id="previousButton">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-icon-button mwlCalendarToday [(viewDate)]="viewDate" id="todayButton">
              <mat-icon>today</mat-icon>
            </button>
            <button mat-icon-button mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" id="nextButton">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </div>
        <div>
          @switch (view) {
            @case ('month') {
              <mwl-calendar-month-view
                [viewDate]="viewDate"
                [events]="events"
                [locale]="locale"
                [refresh]="refresh"
                [activeDayIsOpen]="activeDayIsOpen"
                (dayClicked)="dayClicked($event.day)"
                (eventClicked)="handleEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
              ></mwl-calendar-month-view>
            }
            @case ('week') {
              <mwl-calendar-week-view
                [viewDate]="viewDate"
                [locale]="locale"
                [events]="events"
                [refresh]="refresh"
                (eventClicked)="handleEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
              ></mwl-calendar-week-view>
            }
            @case ('day') {
              <mwl-calendar-day-view
                [viewDate]="viewDate"
                [locale]="locale"
                [events]="events"
                [refresh]="refresh"
                (eventClicked)="handleEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
              ></mwl-calendar-day-view>
            }
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
